export default __webpack_public_path__ + "static/media/sort-numeric-descending-selected.b3e091b2.svg";